"use client";

const Table = ({ data, columns, keyExtractor = (item) => item._id || item.id }) => {
  // Ensure data is an array to prevent .map() errors
  const tableData = Array.isArray(data) ? data : [];

  if (tableData.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No data available</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto shadow-lg rounded-lg">
      <table className="min-w-full bg-white">
        {/* Table Header */}
        <thead className="bg-gray-50">
          <tr>
            {columns.map((column) => (
              <th
                key={column.field}
                className={`px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider ${
                  column.headerClassName || ""
                }`}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>

        {/* Table Body */}
        <tbody className="divide-y divide-gray-200">
          {tableData.map((item, index) => (
            <tr
              key={keyExtractor(item) || index}
              className="hover:bg-gray-50 transition-colors duration-200"
            >
              {columns.map((column) => (
                <td
                  key={`${keyExtractor(item) || index}-${column.field}`}
                  className={`px-6 py-4 text-sm ${
                    column.cellClassName || "text-gray-900"
                  }`}
                >
                  {column.render ? column.render(item) : item[column.field]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Optional: Pagination */}
      {/* <div className="px-6 py-4 bg-gray-50">
        <Pagination />
      </div> */}
    </div>
  );
};

export default Table;